import type { ParsedToken } from '../../../types/QueryBuilder';

export function dropExtraLogicBools(tokens: ParsedToken[]): ParsedToken[] {
  const isContent = (token: ParsedToken) => token.type !== 'LOGIC_BOOL' && token.type !== 'LOGIC_NOT';

  const result: ParsedToken[] = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.type !== 'LOGIC_BOOL') {
      result.push(token);
      continue;
    }

    let left = -1;
    for (let j = i - 1; j >= 0; j--) {
      if (isContent(tokens[j])) {
        left = j;
        break;
      }
    }
    let right = -1;
    for (let j = i + 1; j < tokens.length; j++) {
      if (isContent(tokens[j])) {
        right = j;
        break;
      }
    }
    if (left < 0 || right < 0) {
      continue;
    }

    let earlierConnector = false;
    for (let j = left + 1; j < i; j++) {
      if (tokens[j].type === 'LOGIC_BOOL') {
        earlierConnector = true;
        break;
      }
    }
    if (earlierConnector) {
      continue;
    }

    let chosen: Extract<ParsedToken, { type: 'LOGIC_BOOL' }> = token;
    for (let j = i + 1; j < right; j++) {
      const mid = tokens[j];
      if (mid.type === 'LOGIC_BOOL' && mid.value === 'OR') {
        chosen = mid;
        break;
      }
    }
    result.push(chosen);
  }
  return result;
}

export function dropDanglingLogicNots(tokens: ParsedToken[]): ParsedToken[] {
  const result: ParsedToken[] = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.type === 'LOGIC_NOT') {
      const next = tokens[i + 1];
      if (next?.type === 'FILTER' || next?.type === 'EXPRESSION') {
        result.push(token);
      }
      continue;
    }
    if (token.type === 'EXPRESSION') {
      result.push({ ...token, inner: dropDanglingLogicNots(token.inner) });
      continue;
    }
    result.push(token);
  }
  return dropExtraLogicBools(result);
}

function stripFreeTextTokens(tokens: ParsedToken[]): ParsedToken[] {
  const result: ParsedToken[] = [];
  for (const token of tokens) {
    if (token.type === 'FREE_TEXT') {
      continue;
    }
    if (token.type === 'EXPRESSION') {
      const inner = stripFreeTextTokens(token.inner);
      if (inner.length === 0) {
        continue;
      }
      result.push({ ...token, inner });
      continue;
    }
    result.push(token);
  }
  return result;
}

export function tokensForExecutableQuery(tokens: ParsedToken[]): ParsedToken[] {
  return dropDanglingLogicNots(stripFreeTextTokens(tokens));
}
